import {
  getGoogleMapsApiKey,
  getGoogleMapsDefaultZoomLevel,
  getGoogleMapsMapId,
  getGoogleMapsTipText,
  getAllGoogleMapsSettings,
} from '@/constants/forms-api.const';
import { RequestServices as _http } from '@/services/common/request.services';
import { GoogleMapSettingsItem } from '@/interfaces/components/google-map-item.interface';

export const GoogleMapService = {
  getGoogleMapsApiKey(): Promise<string> {
    return _http.HttpGet(`${getGoogleMapsApiKey}`);
  },
  getGoogleMapsMapId(): Promise<string> {
    return _http.HttpGet(`${getGoogleMapsMapId}`);
  },
  getGoogleMapsDefaultZoomLevel(): Promise<number> {
    return _http.HttpGet(`${getGoogleMapsDefaultZoomLevel}`);
  },
  getGoogleMapsTipText(): Promise<string> {
    return _http.HttpGet(`${getGoogleMapsTipText}`);
  },
  getAllGoogleMapsSettings(): Promise<GoogleMapSettingsItem> {
    return _http.HttpGet(`${getAllGoogleMapsSettings}`);
  },
};
